// components/admin/PaymentVerification/styles.js
import styled from 'styled-components';

export const VerificationContainer = styled.div`
    padding: ${props => props.theme.spacing.xl};

    .empty-state {
        text-align: center;
        padding: ${props => props.theme.spacing.xl};
        color: ${props => props.theme.colors.text.secondary};
        background: white;
        border-radius: ${props => props.theme.borderRadius.lg};
    }
`;

export const VerificationHeader = styled.div`
    margin-bottom: ${props => props.theme.spacing.xl};

    h2 {
        font-size: ${props => props.theme.typography.sizes['2xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;

export const PaymentsList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: ${props => props.theme.spacing.lg};
`;

export const PaymentCard = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xl};
    box-shadow: ${props => props.theme.shadows.sm};
    transition: transform ${props => props.theme.transitions.normal};

    &:hover {
        transform: translateY(-2px);
        box-shadow: ${props => props.theme.shadows.md};
    }
`;

export const PaymentInfo = styled.div`
    margin-bottom: ${props => props.theme.spacing.lg};
    padding-bottom: ${props => props.theme.spacing.lg};
    border-bottom: 1px solid ${props => props.theme.colors.border};

    .user-info {
        margin-bottom: ${props => props.theme.spacing.md};

        h3 {
            font-size: ${props => props.theme.typography.sizes.lg};
            margin-bottom: ${props => props.theme.spacing.xs};
        }

        p {
            color: ${props => props.theme.colors.text.secondary};
        }
    }

    .plan-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .plan-name {
            font-weight: ${props => props.theme.typography.weights.medium};
            color: ${props => props.theme.colors.primary.main};
        }

        .date {
            font-size: ${props => props.theme.typography.sizes.sm};
            color: ${props => props.theme.colors.text.secondary};
        }
    }
`;

export const AmountInfo = styled.div`
    background: ${props => props.theme.colors.background.alt};
    padding: ${props => props.theme.spacing.lg};
    border-radius: ${props => props.theme.borderRadius.md};
    margin-bottom: ${props => props.theme.spacing.lg};

    .amount-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: ${props => props.theme.spacing.sm};

        &.discount {
            color: ${props => props.theme.colors.success.main};
        }

        &.total {
            margin-top: ${props => props.theme.spacing.md};
            padding-top: ${props => props.theme.spacing.md};
            border-top: 1px dashed ${props => props.theme.colors.border};
            font-weight: ${props => props.theme.typography.weights.bold};
        }
    }
`;

export const ProofSection = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${props => props.theme.spacing.md};
    margin-bottom: ${props => props.theme.spacing.lg};

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${props => props.theme.spacing.sm};
    }

    a {
        text-decoration: none;
        button {
            width: 100%;
        }
    }
`;

export const VerificationActions = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${props => props.theme.spacing.md};

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${props => props.theme.spacing.sm};
    }
`;

export const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${props => props.theme.zIndex.modal};
    padding: ${props => props.theme.spacing.xl};
`;

export const ModalContent = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xl};
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;

    h3 {
        font-size: ${props => props.theme.typography.sizes.xl};
        margin-bottom: ${props => props.theme.spacing.lg};
    }
`;

export const ImagePreview = styled.div`
    border-radius: ${props => props.theme.borderRadius.md};
    overflow: hidden;
    
    img {
        width: 100%;
        height: auto;
        display: block;
    }
`;

export const RejectForm = styled.div`
    textarea {
        width: 100%;
        padding: ${props => props.theme.spacing.md};
        border: 1px solid ${props => props.theme.colors.border};
        border-radius: ${props => props.theme.borderRadius.md};
        margin-bottom: ${props => props.theme.spacing.lg};
        resize: vertical;
        min-height: 120px;
        font-family: inherit;
        font-size: ${props => props.theme.typography.sizes.md};

        &:focus {
            outline: none;
            border-color: ${props => props.theme.colors.primary.main};
            box-shadow: 0 0 0 2px ${props => props.theme.colors.primary.main}20;
        }
    }

    .actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${props => props.theme.spacing.md};
    }
`;